import { useState } from "react";
import { Dialog, DialogContent, DialogDescription, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { GearSix, CaretUp, CaretDown, Eye, EyeSlash, ArrowCounterClockwise } from "@phosphor-icons/react";

export default function CustomizeCards({ sections, order, hidden, onChange, hide = false }) {
  const [open, setOpen] = useState(false);
  const labels = Object.fromEntries(sections.map((s) => [s.id, s.label]));
  if (hide) return null;

  const move = (i, dir) => {
    const next = [...order];
    const j = i + dir;
    if (j < 0 || j >= next.length) return;
    [next[i], next[j]] = [next[j], next[i]];
    onChange(next, hidden);
  };

  const toggle = (id) => {
    onChange(order, hidden.includes(id) ? hidden.filter((h) => h !== id) : [...hidden, id]);
  };

  const reset = () => onChange(sections.map((s) => s.id), []);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <button data-testid="customize-cards-button"
          className="flex items-center gap-1.5 px-3 py-1.5 rounded-md text-xs font-semibold bg-secondary text-muted-foreground hover:text-foreground transition-colors">
          <GearSix size={14} /> Настроить
        </button>
      </DialogTrigger>
      <DialogContent className="max-w-md" data-testid="customize-cards-dialog">
        <DialogTitle className="text-base">Порядок карточек</DialogTitle>
        <DialogDescription className="text-xs">
          Стрелками меняйте порядок, глазом — скрывайте ненужные. Настройки сохраняются в вашем профиле.
        </DialogDescription>
        <div className="space-y-1 max-h-[55vh] overflow-y-auto pr-1">
          {order.map((id, i) => {
            const isHidden = hidden.includes(id);
            return (
              <div key={id} data-testid={`customize-row-${id}`}
                className={`flex items-center gap-2 rounded-md border border-border/40 px-3 py-2 ${isHidden ? "opacity-50 bg-secondary/20" : "bg-secondary/40"}`}>
                <span className="text-xs flex-1 truncate">{labels[id] || id}</span>
                <button onClick={() => move(i, -1)} disabled={i === 0} data-testid={`customize-up-${id}`}
                  className="p-1 rounded text-muted-foreground hover:text-foreground disabled:opacity-30 transition-colors"><CaretUp size={15} /></button>
                <button onClick={() => move(i, 1)} disabled={i === order.length - 1} data-testid={`customize-down-${id}`}
                  className="p-1 rounded text-muted-foreground hover:text-foreground disabled:opacity-30 transition-colors"><CaretDown size={15} /></button>
                <button onClick={() => toggle(id)} data-testid={`customize-toggle-${id}`}
                  className={`p-1 rounded transition-colors ${isHidden ? "text-[#ff3b30]" : "text-muted-foreground hover:text-foreground"}`}>
                  {isHidden ? <EyeSlash size={15} /> : <Eye size={15} />}
                </button>
              </div>
            );
          })}
        </div>
        <Button variant="outline" size="sm" onClick={reset} data-testid="customize-reset-button">
          <ArrowCounterClockwise size={14} className="mr-1.5" /> Сбросить к стандартному
        </Button>
      </DialogContent>
    </Dialog>
  );
}
